import React from "react";
import { DateRangeChartProps } from "../types";
import { DateRangeChartComponent } from "../components";
import { generateDataCategories, generateXAxisData, getEmissionType } from "../utils";

export const CountryChart = ({
  dateRangeType,
  subTabName,
  currentMainTab,
  ...props
}: DateRangeChartProps) => {
  const generateChartData = (data: any[], emissionType: string) =>
    generateDataCategories(data, emissionType, "country");

  const generateSeriesData = (chartData: any, sortedCategories: string[]) =>
    generateXAxisData(
      chartData,
      sortedCategories,
      dateRangeType,
      getEmissionType(
        subTabName === "location" || subTabName === "market",
        currentMainTab === "Consumption",
        subTabName
      )
    );

  return (
    <DateRangeChartComponent
      {...props}
      dateRangeType={dateRangeType}
      subTabName={subTabName}
      currentMainTab={currentMainTab}
      chartType="country"
      dataKey="country"
      generateChartData={generateChartData}
      generateSeriesData={generateSeriesData}
    />
  );
};
